module.exports = __webpack_public_path__ + "static/media/dew-logo.81954a0d.png";